@if (privateBadge) {
  <div class="private-badge">
    <span class="badge bg-danger">{{ "item.badge.private" | translate }}</span>
  </div>
}
@if (withdrawnBadge) {
  <div class="withdrawn-badge">
    <span class="badge bg-warning">{{ "item.badge.withdrawn" | translate }}</span>
  </div>
}
